import {IGenreJson, IListStatus, IOneAnimeJson, IUserAnimeInfo} from "../../../../nodeserver/structs/database";
import {formatWord, handleFetchError} from "../helpers/functions.js";
import {ServerApi} from "../api.js";
import JSX from "../helpers/react.js";
import {favoriteTypes} from "../config.js";

function GenreItem(g: IGenreJson){
    return(
        <><li><a className={"badge link"} href={g.url}>{g.title}</a></li> </>
    );
}
function RefLogo({name, rating, href, tooltip}: {name: string, rating?: number, href: string, tooltip: string}){
    return (
        <a className={name+"-color link"} data-balloon={tooltip} data-balloon-pos="down" target="_blank" href={href}>
            <div className={[name, "logo-ref"]} />
            <span>{getString(rating)}</span>
        </a>
    );
    function getString(amount?: number){
        if(!amount || amount < 0.01) return '';
        return amount.toLocaleString('en-US', {maximumFractionDigits: 2, minimumFractionDigits: 2});
    }
}

function ActionButton({selected, type}: { selected: boolean, type: IListStatus }) {
    const className = ['fav-type'];
    if(selected) className.push('selected');
    return (
        <span className={className} data-id={type.id} data-balloon={type.title} data-balloon-pos="down"><i className={["fa",favoriteTypes.find(e=>e.id === type.id)?.icon??'']} /></span>
    )
}
function FavoriteTypeIcon({list}: {list: IListStatus}){
    return (
        <span className={["list", favoriteTypes.find(e=>e.id ===list.id)?.class??'']}><i className={["fa", favoriteTypes.find(e=>e.id ===list.id)?.icon??'']} /></span>
    );
}
function ActionButtons({user}: {user: IOneAnimeJson['user']}){
    if(!user) return false;

    return(
        <div className="action-buttons">
            <div className="anime-fav-type">
                {
                    ...
                        favoriteTypes
                            .filter(e=>e.id !== 4)
                            .map(type=>ActionButton({selected: user.list.list?.id === type.id, type}))
                }
                {/*<span className={`fav-type${user.list.list?.id==0?' selected':''}`} data-id="0" data-balloon="Смотрю" data-balloon-pos="down"><i className="fa fa-eye" /></span>*/}
                {/*<span className={`fav-type${user.list.list?.id==2?' selected':''}`} data-id="2" data-balloon="Просмотрено" data-balloon-pos="down"><i className="fa fa-flag-checkered" /></span>*/}
                {/*<span className={`fav-type${user.list.list?.id==1?' selected':''}`} data-id="1" data-balloon="В планах" data-balloon-pos="down"><i className="fa fa-cloud" /></span>*/}
                {/*<span className={`fav-type${user.list.list?.id==3?' selected':''}`} data-id="3" data-balloon="Брошено" data-balloon-pos="down"><i className="fa fa-eye-slash" /></span>*/}
            </div>
        </div>
    );
}
function ContentRefIds({remoteIds, rating}: {remoteIds: IOneAnimeJson['remote_ids'], rating: IOneAnimeJson['rating']}){
    const array = [];
    if(remoteIds.shikimori_id) array.push(
        <RefLogo href={"https://shikimori.io/animes/"+remoteIds.shikimori_id} rating={rating?.shikimori_rating} name="shikimori" tooltip="Shikimori"/>
    );
    if(remoteIds.worldart_id) array.push(
        <RefLogo name="worldart"
                 tooltip="Worl Art"
                 href={`http://www.world-art.ru/${remoteIds.worldart_type??'animation'}/${remoteIds.worldart_type??'animation'}.php?id=${remoteIds.worldart_id}`}
                 rating={rating?.worldart_rating} />
    );
    if(remoteIds.kp_id) array.push(
        <RefLogo tooltip="Kinopoisk" name="kinopoisk" href={'//kinopoisk.ru/film/'+remoteIds.kp_id} rating={rating?.kp_rating} />
    );
    if(remoteIds.myanimelist_id) array.push(
        <RefLogo tooltip="MyAnimeList" name="mal" href={"//myanimelist.net/anime/"+remoteIds.myanimelist_id} rating={rating?.myanimelist_rating} />
    );
    if(remoteIds.anidub_id) array.push(
        <RefLogo tooltip="AniDub" name="anidub" href={"//anidub.live/?newsid="+remoteIds.anidub_id} rating={rating?.anidub_rating} />
    );
    // if(remoteIds.sr_id) array.push(
    //     <RefLogo tooltip="SovetRomantica" name="sr" href={"//sovetromantica.com/anime/"+remoteIds.sr_id} />
    // );
    if(remoteIds.anilibria_alias) array.push(
        <RefLogo tooltip="AniLibria" name="anilibria" href={`//anilibria.tv/release/${remoteIds.anilibria_alias}.html`} />
    );
    return (
        Object.keys(remoteIds).length &&
        <li className="content-ref-ids" style="min-height: 30px; padding-bottom: 5px">
            {...array}
        </li>
    )
}
export class PreviewAnimeDialog {

    private readonly $element:JQuery
    public isHovered: boolean = false;
    private constructor(private readonly anime: IOneAnimeJson) {
        this.$element = this.buildDialog();
        this.addEvents();
    }
    private buildDialog() : JQuery{
        const ans = (
<div className="preview-anime bordered-overflow" data-anime-id={this.anime.anime_id}>
    <a href={"/catalog/item/"+this.anime.anime_url} className="img-a">
        {!!this.anime.user &&
        <div className={`favorite-favorite fav-type-fav${this.anime.user.list.is_fav?' selected':''}`} data-id="4" style="right: 12px;left: auto;">
            <div className="favourite-button top-right" data-balloon="Любимые" data-balloon-pos="right"><i className="far fa-heart" /></div>
        </div>
        }
        <img src={this.anime.poster.medium} alt="" className="bordered" sizes="135px" srcset={`${this.anime.poster.medium} 184w, ${this.anime.poster.big} 250w, ${this.anime.poster.huge} 400w`}/>
    </a>
    <div className="preview-content">
        <div className="title">
            <a href={"/catalog/item/"+this.anime.anime_url}>{this.anime.title}</a>
        </div>
    </div>
    
    <div className="additional-data">
        <ul className="content-main-info">
        {/*<ContentRefIds remoteIds={this.anime.remote_ids} rating={this.anime.rating}/>*/}
        <li className="rating-li">
            {
                !!this.anime.rating?.average &&
                <span className="rating-info" data-id={this.anime.anime_id} style="padding: 0;margin: 0;">
                    <span className="fa fa-star rating-star" data-id={this.anime.anime_id}></span>
                    <span className="main-rating materiable" style="height: 24px">{this.anime.rating.average.toFixed(2)}</span>
                    <span className="main-rating-info" style="margin-right: 4px"><span>{this.anime.rating.counters}</span> {formatWord(this.anime.rating.counters, 'голос', 'голоса', 'голосов')} </span>
                    <span className={"user-rating" + (this.anime.user?.rating?'':' hidden')} title="Мой рейтинг" style="margin: 0;"><i className="fa fa-star rating-star"> {this.anime.user?.rating??0}</i></span>
                </span>
            }{!!this.anime.rating?.average && ' | '}{this.anime.year}{
                !!this.anime.type.shortname && ' | '+this.anime.type.shortname
            } | <span className={"badge "+this.anime.anime_status.class} style={{marginLeft: '3px'}}>{this.anime.anime_status.title}</span>
        </li>
        {!!this.anime.genres.length &&
            <li className="categories-list no-comma">
                <span>Жанры:</span>
                <ul>
                {
                    ...this.anime.genres.map(GenreItem)
                }
                </ul>
            </li>
        }
        {!!this.anime.creators.length &&
        <li className="categories-list">
            <span className="creator">Режиссер:</span>
            <ul className="categories-list">
                {
                    ...this.anime.creators.map(c=>
                        <li><a href={c.url}>{c.title}</a></li>
                    )
                }
            </ul>
        </li>
            }
        {!!this.anime.studios.length &&
            <li className="categories-list">
                <span className="studio">Студия:</span>
                <ul className="categories-list">
                    {
                        ...this.anime.studios.map(c=>
                            <li><a href={c.url}>{c.title}</a></li>
                        )
                    }
                </ul>
            </li>
        }
        {
            !!this.anime.episodes.count &&(
                this.anime.episodes.aired && this.anime.episodes.count !== this.anime.episodes.aired?
                    (<li><b>Вышло серий</b>: {this.anime.episodes.aired} из {this.anime.episodes.count}</li>) :
                    (<li><b>Количество серий</b>: {this.anime.episodes.count}</li>)
            )
        }   
        {/*<li><span>Возрастной рейтинг:</span> {this.anime.min_age.title}</li>*/}
    </ul>
    </div>
    <ActionButtons user={this.anime.user}/>
</div>);
        return $(ans).appendTo('body');
    }
    moveTo($el: JQuery){
        // const top = this.preventMoveY($el.offset()!.top - this.$element.height()!, $el.offset()!.top + $el.height()! + 5),
        //     left = this.preventMoveX($el.offset()!.left - this.$element.width()!/2 ) + 30;
        const top = this.preventMoveY($el.offset()!.top - this.$element.height()!/2 + $el.height()!/2 - 10);
        const left = this.preventMoveX($el.offset()!.left + $el.width()!+10, $el.offset()!.left! - this.$element.width()!-10) ;
        this.$element.css({
            top: top+'px',
            left: left+'px',
            display: 'none'
        }).fadeIn();
        return this
    }
    catchMouseout($el: JQuery){
        $el.one('mouseleave', async ()=>{
            await new Promise(r=>setTimeout(r, 200));
            if(!this.isHovered)
                this.hide();
        })
        return this;
    }
    addEvents(){
        this.$element.on('mouseenter', ()=>{
            this.isHovered=true
        }).on('mouseleave', async ()=>{
            this.isHovered=false;
            await new Promise(r=>setTimeout(r, 200));
            if(!this.isHovered) this.hide();
        })
    }
    hide(){
        this.$element.fadeOut()
            .promise()
            .done(() => this.$element.remove())
        PreviewAnimeDialog.createdInstances.splice(PreviewAnimeDialog.createdInstances.indexOf(this), 1)
    }
    private static createdInstances: PreviewAnimeDialog[] = [];
    static createAnimePreviewDialog($element: JQuery, anime: IOneAnimeJson){
        const dialog = new PreviewAnimeDialog(anime)
            .moveTo($element)
            .catchMouseout($element);
        $element.one('mousedown', ()=>dialog.hide())
        this.createdInstances.push(dialog);
        return dialog;
    }
    static animeExists(animeId: number){
        return this.createdInstances.some(e=>e.anime.anime_id == animeId);
    }

    private preventMoveX(newLeftA: number, newLeftB: number) {
        let newLeft: number
        if(newLeftB < 0) newLeft = newLeftA;
        else if (newLeftA + this.$element.outerWidth()! + 50 > $(document).width()!) {
            newLeft = newLeftB
            // newLeft = $(document).width()! - this.$element.outerWidth()! - 50; // keep the element inside the right edge of the document
        }
        else newLeft = newLeftA;

        return newLeft;
    }
    private preventMoveY(newTop: number, newTop1?: number) {
        if (newTop < window.scrollY + 50) {
            newTop = newTop1 ?? (window.scrollY + 50); // keep the element inside the Y axis of the document
        }

        return newTop;
    }
    static onFavChanged(animeId: number, isFavorite: boolean){
        const list = this.createdInstances.find(e=>e.anime.anime_id===animeId)?.anime?.user?.list;
        if(list) list.is_fav = isFavorite;
        downloadCaches.forEach(e=>{
            if(e.anime_id == animeId){
                const list = e.user?.list;
                if(list) list.is_fav = isFavorite;
            }
        });
        const $existsColumn = $(`.anime-column[data-anime-id=${animeId}] .image-block`);
        if($existsColumn[0]) {
            $existsColumn.find(favoriteTypes.map(e=>"."+e.class).join(',')).remove();
            if(isFavorite)
                $(<FavoriteTypeIcon list={favoriteTypes.find(e=>e.id === 4)!}/>).appendTo($existsColumn);
            else downloadCaches.forEach(a=>{
                if(a.anime_id === animeId && a.user){
                    this.onListChanged(animeId, a.user.list.list)
                }
            });
        }
    }
    static onListChanged(animeId: number, list: IUserAnimeInfo['list']['list']|null){
        const userList = this.createdInstances.find(e=>e.anime.anime_id===animeId)?.anime?.user?.list;
        if(userList) userList.list = list;
        downloadCaches.forEach(e=>{
            if(e.anime_id == animeId){
                const list1 = e.user?.list;
                if(list1) list1.list = list;
            }
        });
        if(!userList?.is_fav??false) {
            const $existsColumn = $(`.anime-column[data-anime-id=${animeId}] .image-block`);
            if ($existsColumn[0]) {
                $existsColumn.find(favoriteTypes.map(e => "." + e.class).join(',')).remove();
                if (list)
                    $(<FavoriteTypeIcon list={list}/>).appendTo($existsColumn);
                else downloadCaches.forEach(a => {
                    if (a.anime_id === animeId && a.user?.list?.is_fav) {
                        this.onFavChanged(animeId, true)
                    }
                });
            }
        }

    }
}

const downloadCaches = new Map<number, IOneAnimeJson>();
$('html').on('mouseenter', '.anime-column:not(.user-column),.one-video-update,.one-schedule-update', async function (){
    //@ts-ignore
    if(navigator['userAgentData']?.['mobile'] || window.innerWidth < 1024) return;
    let inside = true;
    $(this).one('mouseleave', ()=>{inside=false});
    await new Promise(r=>setTimeout(r, 400));
    if(inside){
        const id = $(this).data('anime-id');
        showAnimeDialog(id, ()=>inside, $(this));
    }
})
    .on('click mouseenter', '.show-dialog', async function(){
        let inside = true;
        $(this).one('mouseleave', ()=>{inside=false});
        const id = $(this).parent().data('anime-id');
        return showAnimeDialog(id, ()=>inside, $(this));

    })
export async function showAnimeDialog(id: number, showAfterLoad: ()=>boolean, element: JQuery){
    if(PreviewAnimeDialog.animeExists(id)) return;
    try {
        const animeData = downloadCaches.has(id)? downloadCaches.get(id)! : (await ServerApi.anime.get(id));
        downloadCaches.set(id, animeData);
        if(showAfterLoad())
            PreviewAnimeDialog.createAnimePreviewDialog(element, animeData);
    } catch (e){
        handleFetchError(e)
    }

}